module.exports = __webpack_public_path__ + "static/img/6.4534465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/6.png
// module id = a6AZ
// module chunks = 0